import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { UtilitiesService } from 'src/app/core/utilities.service';

declare const $: any;

@Component({
  selector: 'orders-cod',
  templateUrl: './orders-cod.component.html',
  styleUrls: ['./orders-cod.component.scss']
})
export class OrdersCodComponent implements OnInit {

  bearer;
  store_id;

  store_order_id;
  codData: any = [];
  maxQtyProduct = [];
  value = [];
  product_items = [];
  product_items2 = [];
  mixture_data = [];
  mixtureId = [];
  mixtureqty = [];
  selectedStatus;
  statusFilters = ['Approve','Cancel'];
  selectedFilter = '';
  remark = '';
  dataReturn = [];

  closeResult = '';
  success = 'success';

  loadingInfo = false;


  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private router:Router,
    public utils: UtilitiesService,
    ) {
  }

  ngOnInit(): void {
    let me = this;
    me.bearer = localStorage.getItem('bearer');
    me.store_id = localStorage.getItem('store_id');
    me.codData = JSON.parse(localStorage.getItem('codData'));
    me.maxQtyProduct = me.codData.order_details;
    me.store_order_id = me.codData.store_order_id;
    for (let i = 0; i < me.maxQtyProduct.length; i++) {
      this.value.push(me.maxQtyProduct[i].data.quantity);
    }
    for(let item of me.maxQtyProduct){
      me.product_items.push({quantity:item.data.quantity,product_id:item.data.product_id});
      for(let productitem of me.product_items){
        if(item.data.product_id === productitem.product_id && item.mixture_product !=undefined){
          for(let mixture of item.mixture_product){
            me.mixtureId = mixture.data.p_id;
            me.mixtureqty = mixture.data.quantity;
            me.mixture_data.push({pid:me.mixtureId,qtyValue:me.mixtureqty});
          }
        }
      }
      if(item.data.product_id && item.mixture_product !=undefined){
        me.product_items2.push({quantity:item.data.quantity,product_id:item.data.product_id,mixture_data:me.mixture_data});
        me.product_items2.map(x =>{
          let index = me.product_items.findIndex(d=> d.product_id === x.product_id)
          me.product_items[index] = x
        })
      }
      me.mixture_data = [];
    }
    console.log('coddata check',me.codData);
  }




  handleMinus(value,p_id) {
    this.value[value]--;
    for(var item of this.product_items ){
      if(p_id === item.product_id){
        item.quantity = this.value[value];
      }else if(p_id === item.product_id && item.mixture_data != undefined){
        item.quantity = this.value[value];
        for( let mixture of item.mixture_data){
          mixture.qtyValue = this.value[value];
        }
      }
    }
    // this.productItem.push({quatity:this.value[value],product_id:p_id})
    // console.log('check pid',p_id) ;
    // console.log('product- check',this.product_items);
  }
  handlePlus(value,p_id) {
    this.value[value]++;
    for(var item of this.product_items ){
      if(p_id === item.product_id && item.mixture_data != undefined){
        item.quantity = this.value[value];
        for( let mixture of item.mixture_data){
          mixture.qtyValue = this.value[value];
        }
      }else{
        if(p_id === item.product_id){
          item.quantity = this.value[value];
        }
      }
    }
    // this.productItem.push({quatity:this.value[value],product_id:p_id})
    // console.log('check pid',p_id) ;
    // console.log('product+ check',this.product_items);
  }

  selectedStatusclick(filter){
    this.selectedFilter = filter;
  }

  saveCod(status) {
    this.loadingInfo = true;
    if (status === 'Approve') {
      let body = {
        store_order_id: this.store_order_id,
        product_items: this.product_items,
      };

      this.svc.updateCodStatus(body, this.bearer).subscribe(
        (res) => {
          let msg = res['data'];
          if (res['status_code'] === 400 || res['status_code'] === 'error') {
            if (msg?.fiv5s_api_error !== undefined) {
            this.utils.notify.showError(res['data']['fiv5s_api_error']);
            } else {
              this.utils.notify.showError( res['message']);
            }
            this.loadingInfo = true;
            setTimeout(() => {
              this.loadingInfo = false;
            }, 3000);
          } else {
            this.utils.notify.showSuccess(this.utils.translate("Updated Successfully!"));
            this.loadingInfo = true;
            setTimeout(() => {
              this.router.navigate(['/dashboard/orders']);
              this.loadingInfo = false;
            }, 3000);
          }
        },
        (error) => {
          if (error['error']['status_code'] === 400 || error['error']['status_code'] === 'error') {
            if (error?.data?.fiv5s_api_error !== undefined) {
              this.utils.notify.showError(error['data']['fiv5s_api_error']);
            } else {
              if (error?.['error']?.['message']) {
                if (typeof error['error']['message'] === 'string') {
                  this.utils.notify.showError(error['error']['message']);
                } else {
                  let msg = '';
                  if (error?.['error']?.['message']?.['error']) {
                    msg = error['message']['error']
                  } else {
                    Object.keys(error['error']['message']).forEach((item) => {
                      msg += error['error']['message'][item] + ' ';
                    });
                  }
                  this.utils.notify.showError(msg);
                }
              } else {
                this.utils.notify.showError(error['message']);
              }
            }
            setTimeout(() => {
              this.loadingInfo = false;
            }, 3000);
          } else {
            this.utils.notify.showError(error['message']);
            this.loadingInfo = true;
            setTimeout(() => {
              this.loadingInfo = false;
            }, 3000);
          }
        }
      );
    }
    if (status === 'Cancel') {
      let body = {
        store_order_id: this.store_order_id,
        product_items: this.product_items,
        remark: this.remark,
      };

      this.svc.cancelCodStatus(body, this.bearer).subscribe(
        (res) => {
          this.utils.notify.showSuccess(this.utils.translate("Updated Successfully!"));
          setTimeout(() => {
            this.router.navigate(['/dashboard/orders']);
          }, 3000);
        },
        (error) => {
          if (error['error']['status_code'] === 400 || error['error']['status_code'] === 'error') {
            this.utils.notify.showError(error['message']);
          }
        }
      );
    }
  }
}
